import { render, staticRenderFns } from "./SpouseRiderWidget.vue?vue&type=template&id=b11a56f8&scoped=true"
import script from "./SpouseRiderWidget.vue?vue&type=script&lang=js"
export * from "./SpouseRiderWidget.vue?vue&type=script&lang=js"
import style0 from "./SpouseRiderWidget.vue?vue&type=style&index=0&id=b11a56f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11a56f8",
  null
  
)

export default component.exports